<template >
  <base-dialog-form ref="gestEventoDialog" :title="computedTitle" :text="eventData.titolo" color="secondary"
    icon="mdi-calendar-multiple-check">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="method !== 'VIEW'" @click="saveEvento" color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="method === 'EDIT'" @click="deleteEvento" color="error">{{ $t("delete") }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <v-row class="mb-2">
      <v-tabs v-model="tabs" background-color="transparent" color="secondary" slider-color="secondary">
        <v-tab id="tab-title" class="mr-3">
          <v-icon class="mr-2">mdi-calendar-text</v-icon>
          {{ $t("event_data") }}
        </v-tab>
        <v-tab id="tab-descr" class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t("long_description") }}
        </v-tab>

        <v-tab :v-if="eventData && eventData.pacchetti" v-for="pacchetto in eventData.pacchetti"
          v-bind:key="pacchetto.idPacchetto" class="mr-3">
          <v-icon class="mr-2">mdi-circle-double</v-icon>
          {{ pacchetto.descr }}
          <v-btn v-if="method !== 'VIEW' &&
            (!pacchetto.postiOccupati || pacchetto.postiOccupati === 0)
            " icon color="error" min-width="0" text @click.native="deletePacchetto(pacchetto)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-tab>
        <v-btn v-if="method !== 'VIEW'" color="primary" @click="newPacchetto()">{{ $t("new_packet") }}</v-btn>
      </v-tabs>
    </v-row>
    <form>
      <v-tabs-items v-model="tabs" class="transparent tabs-container">
        <v-tab-item>
          <v-row>
            <v-col md="6" cols="12" class="text-center">
              <v-row>
                <v-col md="6" cols="12">
                  <v-text-field v-model="eventData.titolo" :disabled="method === 'VIEW'" :label="$t('title')"
                    :rules="required" hide-details="auto"></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-select v-model="eventData.certRequired" :items="listTypeCertValid" :disabled="method === 'VIEW'"
                    :menu-props="{ maxHeight: '400' }" :label="$t('check_cert')" required color="primary"
                    persistent-hint></v-select>
                </v-col>
                <v-col md="4" cols="12">
                  <v-text-field v-model="eventData.type" :disabled="method === 'VIEW'" :label="$t('type')"
                    :rules="required" hide-details="auto"></v-text-field>
                </v-col>

                <v-col md="4" cols="6">
                  <my-datepicker v-model="eventData.dateInz" :disabled="method === 'VIEW'" :label="$t('date_inz')"
                    required="true" />
                </v-col>
                <v-col md="4" cols="6">
                  <my-datepicker v-model="eventData.dateEnd" :disabled="method === 'VIEW'" :label="$t('date_end')"
                    required="true" />
                </v-col>
                <v-col md="4" cols="12">
                  <v-layout row wrap justify-center>
                    <v-switch :disabled="method === 'VIEW'" v-model="eventData.attivo"
                      :label="$t('active_m_s')"></v-switch>
                  </v-layout>
                </v-col>
                <v-col md="4" cols="12">
                  <v-layout row wrap justify-center>
                    <v-switch :disabled="method === 'VIEW'" v-model="eventData.onlySoci"
                      :label="$t('only_affiliates')"></v-switch>
                  </v-layout>
                </v-col>
                <v-col class="text-center" md="4" cols="12">
                  <v-layout row wrap justify-center>
                    <v-switch :disabled="method === 'VIEW'" v-model="eventData.sport4life"
                      :label="$t('sport4life')"></v-switch>
                  </v-layout>
                </v-col>
              </v-row>
              <v-row v-if="ifEnte">
                <v-col md="8" cols="12">
                  <v-select v-model="eventData.discipline" :disabled="method === 'VIEW'" :items="listDiscipline"
                    :menu-props="{ maxHeight: '400' }" :label="$t('disciplines')" multiple required chips dense
                    color="primary" :hint="$t('pick_your_disciplines')"></v-select>
                </v-col>
                <v-col class="text-center" md="4" cols="12">
                  <v-layout row wrap justify-center>
                    <v-switch :disabled="method === 'VIEW'" v-model="eventData.showInAsd"
                      :label="$t('show_in_asd')"></v-switch>
                  </v-layout>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-select v-model="eventData.locId" :items="listLocation" :disabled="method === 'VIEW'"
                    :menu-props="{ maxHeight: '400' }" :label="$t('location')" required color="primary"
                    :hint="$t('pick_your_location')" persistent-hint></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="6" cols="12" text-center>
              <my-img-uploader ref="imageUploader" v-model="eventData.image" :readOnly="method === 'VIEW'" :width="600"
                :height="300" :placeholder="$t('click_drag_here')"></my-img-uploader>
            </v-col>
          </v-row>
          <v-row style="margin-top: 10px;">
            <v-col md="4" cols="12">
              <v-select v-model="eventData.modPag" :items="listPayment" :disabled="method === 'VIEW'"
                :menu-props="{ maxHeight: '400' }" multiple required dense chips color="primary"
                :hint="$t('pick_your_payments')" :label="$t('payment')" persistent-hint></v-select>
            </v-col>
            <v-col md="2" cols="12">
              <v-switch :disabled="method === 'VIEW'" v-model="eventData.forceOrderApprove"
                :label="$t('force_order_approve')"></v-switch>
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field v-model="eventData.shortDescr" :disabled="method === 'VIEW'" :label="$t('short_description')"
                :rules="required" hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>

          <tiptap-vuetify :extensions="extensions" class="fullDex" :disabled="method === 'VIEW'"
            v-model="eventData.descr"></tiptap-vuetify>

        </v-tab-item>
        <v-tab-item :v-if="eventData && eventData.pacchetti" v-for="pacchetto in eventData.pacchetti"
          v-bind:key="pacchetto.idPacchetto" class="mr-3">
          <v-row>
            <v-col md="5" cols="12">
              <v-text-field v-model="pacchetto.descr" :disabled="method === 'VIEW'" :label="$t('short_description')"
                :rules="required" hide-details="auto"></v-text-field>
            </v-col>
            <v-col md="1" cols="6">
              <v-switch :disabled="method === 'VIEW'" v-model="pacchetto.multiscelta"
                :label="$t('multi_choise')"></v-switch>
            </v-col>
            <v-col md="3" cols="6">
              <v-switch :disabled="method === 'VIEW'" v-model="pacchetto.required" :label="$t('required')"></v-switch>
            </v-col>

            <v-col md="3" cols="12">
              <v-card-actions class="justify-center">
                <v-btn v-if="method !== 'VIEW'" color="primary" @click="newDetails(pacchetto)">{{ $t("new_details")
                }}</v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
          <v-container v-if="pacchetto.dettagli && pacchetto.dettagli.length > 0">
            <v-card v-for="dettaglio in pacchetto.dettagli" v-bind:key="dettaglio.idDettaglio" class="my-5">
              <v-container>
                <v-row>
                  <v-col md="11" cols="12">
                    <v-text-field v-model="dettaglio.testo" :disabled="method === 'VIEW'" :label="$t('description')"
                      :rules="required" hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="1" cols="12">
                    <v-card-actions class="justify-center">
                      <v-btn v-if="method !== 'VIEW' &&
                        (!dettaglio.postiOccupati ||
                          dettaglio.postiOccupati === 0)
                        " text color="error" min-width="0" @click.native="deleteDettaglio(pacchetto, dettaglio)">
                        <v-icon>mdi-delete</v-icon>
                        {{ $t("delete") }}
                      </v-btn>
                    </v-card-actions>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="8" cols="12">
                    <v-text-field v-model="dettaglio.opzioni" :disabled="method === 'VIEW' || dettaglio.idGareDettaglio"
                      :label="$t('options')" :rules="required" hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="1" cols="6">
                    <v-text-field v-model="dettaglio.importo" :disabled="method === 'VIEW'" :label="$t('price')"
                      type="number" :rules="required" hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="1" cols="6">
                    <v-text-field v-model="dettaglio.postiTotali" :disabled="method === 'VIEW'" :label="$t('quantity')"
                      type="number" :rules="required" hide-details="auto"></v-text-field>
                  </v-col>

                  <v-col md="1" cols="6">
                    <v-text-field v-model="dettaglio.puntiIscrizione" :disabled="method === 'VIEW'" :label="$t('point')"
                      type="number" :rules="required" hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="1" cols="6">
                    <v-text-field v-model="dettaglio.scontoTessera" :disabled="method === 'VIEW'"
                      :label="$t('affiliation_discount')" type="number" :rules="required"
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="dettaglio.idGareDettaglio" :items="listGare" :disabled="method === 'VIEW'"
                      :menu-props="{ maxHeight: '400' }" :label="$t('competition')" color="primary"
                      :hint="$t('select_competition_type')" persistent-hint
                      @change="updateDettaglioTestoFromGara(dettaglio)"></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
              <!--  <v-col cols="12">{{dettaglio.scontiData}}</v-col> -->
            </v-card>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </form>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import MyImageUploader from "@/components/base/MyImageUploader.vue";

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  name: "edit-evento",

  components: {
    MyDatepicker,
    TiptapVuetify,
    "my-img-uploader": MyImageUploader,
  },
  data() {
    return {
      idEvento: null,
      method: null,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      eventData: {
        pacchetti: [],
      },
      tabs: null,
      listTypeCertValid: [
        { value: null, text: this.$t("no_cert_required") },
        { value: 1, text: this.$t("cert_required_warning") },
        { value: 2, text: this.$t("cert_required_block") },
        { value: 3, text: this.$t("cert_valid_warning") },
        { value: 4, text: this.$t("cert_valid_block") },
      ],
      listDiscipline: [],
      listLocation: null,
      listGare: [{ value: null, text: "" }],
      listPayment: null,
      initalImage: null,
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    updateDettaglioTestoFromGara(dettaglio) {
      let selectedGara = this.listGare.find(el => { return el.value === dettaglio.idGareDettaglio })
      if (selectedGara) {
        dettaglio.titolo = selectedGara.text;
        dettaglio.opzioni = ""
      }
    },
    open(method, idEvento) {
      this.method = method;
      this.idEvento = idEvento;
      this.loadData();
      this.$refs.gestEventoDialog.open();
    },
    loadData() {
      let _ = this;
      _.isFetching = true;

      _.listLocation = [];
      _.chiamataAxios("GET", "/auth/eventi/listLocation").then((response) => {
        _.listLocation = response.data.locations.map(function (item) {
          return { value: item.id, text: item.nome };
        });
      });

      _.listGare = [{ value: null, text: _.$t("none_f") }];
      _.chiamataAxios("POST", "/auth/eventi/getActiveGaraRoutine/", {
        body: { dateInz: _.eventData.dateInz, dateEnd: _.eventData.dateEnd },
      }).then((response) => {
        response.data.forEach((item) => {
          _.listGare.push({
            value: item.idGareDettaglio,
            text: item.fullDescr,
          });
        });
      });

      // Lista discipline
      _.listDiscipline = [];
      _.chiamataAxios("GET", "/auth/ente/listDiscipline").then((response) => {
        _.listDiscipline = response.data.map(function (disciplina) {
          return {
            value: disciplina.idDisciplina,
            text: disciplina.descr,
          };
        });
      });

      _.listPayment = [];
      _.chiamataAxios("GET", "/auth/portal/listAllModPagamento").then(
        (response) => {
          _.listPayment = response.data
            .filter((pag) => {
              return pag.attivo === 1;
            })
            .map(function (item) {
              return { value: item.pagId, text: item.descr };
            });
        }
      );
      if (_.idEvento !== null) {
        let url = "/auth/eventi/getEvento/undefined/" + _.idEvento;
        // Eventi aperti
        _.chiamataAxios("GET", url).then((response) => {
          _.eventData = response.data;
          _.eventData.attivo = _.eventData.attivo === 1 ? true : false;
          _.eventData.showInAsd = _.eventData.showInAsd === 1 ? true : false;
          // Sistema opzioni
          if (_.eventData.pacchetti) {
            _.eventData.pacchetti = _.eventData.pacchetti.map((pacchetto) => {
              pacchetto.dettagli = pacchetto.dettagli.map((dettaglio) => {
                if (dettaglio.opzioni && dettaglio.opzioni.length > 0)
                  dettaglio.opzioni = dettaglio.opzioni.join(",");
                else dettaglio.opzioni = "";
                return dettaglio;
              });
              return pacchetto;
            });
          } else {
            _.eventData.pacchetti = [];
          }
        });
      } else {
        _.eventData = {
          titolo: null,
          descr: null,
          image: null,
          attivo: true,
          showInAsd: false,
          discipline: [],
          pacchetti: [],
        };
      }
    },
    newPacchetto() {
      let newId = 0;
      if (this.eventData && this.eventData.pacchetti) {
        newId =
          Math.max(...this.eventData.pacchetti.map((o) => o.idPacchetto), 0) +
          1;
      } else {
        this.eventData.pacchetti = [];
      }
      this.eventData.pacchetti.push({
        idPacchetto: newId,
        descr: this.$t("new_packet"),
        required: 1,
        multiscelta: 0,
        postiTotali: 0,
        dettagli: [],
      });
      this.tabs = this.eventData.pacchetti.length;
    },
    deletePacchetto(pacchetto2delete) {
      this.eventData.pacchetti = this.eventData.pacchetti.filter(function (
        pacchetto
      ) {
        return pacchetto.idPacchetto !== pacchetto2delete.idPacchetto;
      });
    },
    deleteDettaglio(pacchetto2delete, dettaglio2delete) {
      for (let p = 0; p < this.eventData.pacchetti.length; p++) {
        if (
          this.eventData.pacchetti[p].idPacchetto ===
          pacchetto2delete.idPacchetto
        ) {
          this.eventData.pacchetti[p].dettagli = this.eventData.pacchetti[
            p
          ].dettagli.filter(function (dettaglio) {
            return dettaglio.idDettaglio !== dettaglio2delete.idDettaglio;
          });
        }
      }
    },
    newDetails(pacchetto2add) {
      let _ = this;
      this.eventData.pacchetti = this.eventData.pacchetti.map(function (
        pacchetto
      ) {
        if (pacchetto.idPacchetto === pacchetto2add.idPacchetto) {
          let newId = 0;
          if (pacchetto && pacchetto.dettagli)
            newId =
              Math.max(...pacchetto.dettagli.map((o) => o.idDettaglio), 0) + 1;
          else pacchetto.dettagli = [];

          pacchetto.dettagli.push({
            idDettaglio: newId,
            testo: _.$t("new_details"),
            importo: 0,
            puntiIscrizione: 0,
            postiTotali: 0,
            scontoTessera: 0,
            idGareDettaglio: null,
            opzioni: "",
          });
        }
        return pacchetto;
      });
    },
    deleteEvento(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios("DELETE", "/auth/eventi/deleteEvento/" + _.idEvento, {
            dialogLoader: true,
          }).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });

              _.$emit("isUpdated", "true");
              _.$refs.gestEventoDialog.close();
            }
          });
        }
      });
    },
    saveEvento: function () {
      let _ = this;
      let url = "/auth/eventi/updateEvento/" + _.idEvento;
      let method = "POST";
      _.$refs.imageUploader.updateImage();
      if (_.method == "ADD") {
        url = "/auth/eventi/createEvento";
        method = "PUT";
      }

      let evento = {
        idEvento: _.idEvento,
        dateInz: _.eventData.dateInz,
        dateEnd: _.eventData.dateEnd,
        onlySoci: _.eventData.onlySoci,
        sport4life: _.eventData.sport4life,
        titolo: _.eventData.titolo,
        certRequired: _.eventData.certRequired,
        type: _.eventData.type,
        locId: _.eventData.locId,
        image: _.eventData.image,
        attivo: _.eventData.attivo ? 1 : 0,
        showInAsd: _.eventData.showInAsd ? 1 : 0,
        discipline: _.eventData.discipline ? _.eventData.discipline : [],
        shortDescr: _.eventData.shortDescr,
        descr: _.eventData.descr,
        modPag: _.eventData.modPag,
        forceOrderApprove: _.eventData.forceOrderApprove,
        pacchetti: _.eventData.pacchetti.map((pacchetto) => {
          return {
            idEvento: _.idEvento,
            idPacchetto: pacchetto.idPacchetto,
            descr: pacchetto.descr,
            required: pacchetto.required,
            multiscelta: pacchetto.multiscelta,
            dettagli: pacchetto.dettagli.map((dettaglio) => {
              return {
                idEvento: _.idEvento,
                idPacchetto: pacchetto.idPacchetto,
                idDettaglio: dettaglio.idDettaglio,
                idGareDettaglio: dettaglio.idGareDettaglio,
                testo: dettaglio.testo,
                opzioni: JSON.stringify(
                  dettaglio.opzioni !== "" ? dettaglio.opzioni.split(",") : []
                ),
                importo: dettaglio.importo,
                scontoTessera: dettaglio.scontoTessera,
                postiTotali: dettaglio.postiTotali,
                puntiIscrizione: dettaglio.puntiIscrizione,
              };
            }),
          };
        }),
      };

      _.chiamataAxios(method, url, { dialogLoader: true, body: evento }).then(
        (response) => {
          if (response.msg.esito) {
            let html =
              "<strong>" + response.msg.msgTxt + "</strong>";
            Swal.fire({
              type: "success",
              html: html,
            });
            _.$emit("isUpdated", "true");
            _.$refs.gestEventoDialog.close();
          }
        }
      );
    },
  },
  computed: {
    ifEnte: function () {
      return window.systemData && window.systemData.ifEnte
        ? window.systemData.ifEnte
        : false;
    },
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("edit_event");
      else if (this.method === "VIEW") return this.$t("view_event");
      else if (this.method === "ADD") return this.$t("create_event");
      else return "";
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    idEvento: function (newVal, oldVal) {
      // watch it
      this.loadData();
    },
  },
};
</script>
<style>
.fullDex .tiptap-vuetify-editor__content {
  max-height: 450px;
}
</style>